import CreateNATSConnection from 'src/runtime/nats';

export default function TrackPageViews(path: string) {
    CreateNATSConnection().PushToSubject(`users.server.tracking`, 'page-views', {
        path,
    });
}
